import type { ChangeEvent } from 'react'

import { Input } from '@/components'
import { FilterInputWrapper } from './FilterInputWrapper'
import type { TextInputProps } from './types'

export function TextInput({
  label = 'Value',
  value,
  onChange,
  onKeyDown,
  placeholder = 'Enter value',
}: TextInputProps) {
  return (
    <FilterInputWrapper label={label}>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        onKeyDown={onKeyDown}
      />
    </FilterInputWrapper>
  )
}
